function swapImages () {
    var swapImgs = document.querySelectorAll('.hover-swap-png');
    swapImgs.forEach(function(img){
        img.onmouseover = function(img) {
            var filename = img.srcElement.src.substring(img.srcElement.src.lastIndexOf('/')+1);
            var newname = filename.replace(/(.*)\.(.*)/,"$1-on.$2");
            img.srcElement.src = img.srcElement.src.replace(filename, newname) 
        }
        img.onmouseout = function(img) {
            var filename = img.srcElement.src.substring(img.srcElement.src.lastIndexOf('/')+1);
            var newname = filename.replace(/(.*)-on\.(.*)/,"$1.$2");
            img.srcElement.src = img.srcElement.src.replace(filename, newname) 
        }
    });

    var swapImgsColor = document.querySelectorAll('.hover-swap');
    swapImgsColor.forEach(function(img){
        img.onmouseover = function(img) {
            var filename = img.srcElement.src.substring(img.srcElement.src.lastIndexOf('/')+1);
            var newname = filename.replace(/(.*)\.(.*)/,"$1-color.$2");
            img.srcElement.src = img.srcElement.src.replace(filename, newname) 
        }
        img.onmouseout = function(img) {
            var filename = img.srcElement.src.substring(img.srcElement.src.lastIndexOf('/')+1);
            var newname = filename.replace(/(.*)-color\.(.*)/,"$1.$2");
            img.srcElement.src = img.srcElement.src.replace(filename, newname) 
        }
    });
}

export default swapImages;